import React from 'react'
import { RightPanel } from '../../components/RightPanel';
import { Box, Button, Typography } from '@mui/material';
import { useAuth } from '../../contexts/AuthProvider/AuthProvider';

interface ISubscriptionpaymentSuccessDialogProps {
    open: boolean;
    onClose: () => void;
    plan?: any;
    subscriptionPlan?: any;
}
export const SubscriptionpaymentSuccessDialog: React.FC<ISubscriptionpaymentSuccessDialogProps> = ({ open, onClose }) => {
    const { logoutFromAllDevices } = useAuth()
    return (
        <RightPanel
            heading={"Payment Successful"}
            open={open}
            width="100%"
            // onClose={onClose}
        >
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%' }}>
                <Typography variant="h1" sx={{ fontWeight: "bold", textAlign: "center" }}  >
                    Payment Successful!
                </Typography>
                <Typography variant="h5" mb={2}  >
                    Please login again to continue.
                </Typography>
                <Button variant='contained' onClick={logoutFromAllDevices}>Logout</Button>
            </Box>

        </RightPanel>
    )
}
